import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import PreClearanceForm from '@app/components/apps/PreClearance/PreClearanceForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import PRProductsForm from '@app/components/apps/PRProducts/PRProductsForm';

export const EditPreClearancePage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Pre-Clearance');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/pre-clearance',
      breadcrumbName: 'Pre-Clearance',
    },
    {
      path: '/edit-pre-clearance',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceForm
            type={'edit'}
            editable={true}
            id={id}
            pageTitle={`Edit PreClearance`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditPreClearancePage;
